import ErrorBoundary from '@components/shared/error-boundary'
import Permission from '@constants/permission'
import React, { ReactElement, useEffect } from 'react'
import Table, { ColumnsType } from '@components/shared/table'
import hasPerms from '@utils/has-permission'
import { Add } from '@mui/icons-material'
import { AppDispatch, AttributeType } from '@types'
import { Paper } from '@mui/material'
import { deleteAttribute, getAttributes } from '@store/actions/attributes'
import { selectAttributes } from '@store/selectors/attributes'
import { useConfirm } from '@components/shared/confirm-dialog'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'

const Attributes = (): ReactElement => {
  const confirm = useConfirm()
  const navigate = useNavigate()
  const dispatch = useDispatch<AppDispatch>()
  const attributes = useSelector(selectAttributes)
  const canEdit = hasPerms(Permission.ATTRIBUTES_UPDATE)

  useEffect(() => {
    dispatch(getAttributes())
  }, [])

  const columns: ColumnsType<AttributeType> = [
    { field: 'name', title: 'Display Name' },
    { field: 'label', title: 'Label' },
    { field: 'product_type', title: 'Product Type' },
  ]

  const handleAddNew = () => navigate('/attributes/create')
  const handleRowDelete = (row) => {
    confirm({
      title: 'Be Careful',
      message: 'Are you sure you never want to use this attribute again?',
      onConfirm: () => {
        dispatch(deleteAttribute(row))
      },
    })
  }

  return (
    <>
      <ErrorBoundary>
        <Paper>
          <Table
            columns={columns}
            data={attributes}
            editing
            onRowClick={(row) => `/attributes/${row.id}/edit`}
            rowActions={{
              deletePredicate: () => canEdit,
              onRowDelete: handleRowDelete,
            }}
            rowKey='id'
            title='Attributes'
            toolbarButtons={
              canEdit
                ? [
                    {
                      title: 'Add New Attributes',
                      onClick: handleAddNew,
                      startIcon: <Add />,
                    },
                  ]
                : []
            }
          />
        </Paper>
      </ErrorBoundary>
    </>
  )
}

export default Attributes
